// AWS Cognito configuration - values come from environment variables
// (ui/.env.staging and ui/.env.production), fallbacks are the dev environment
const awsmobile = {
    "aws_project_region": process.env.VUE_APP_AWS_REGION || "eu-central-1",
    "aws_cognito_identity_pool_id": process.env.VUE_APP_COGNITO_IDENTITY_POOL_ID || "eu-central-1:29973125-a47d-4889-80ba-bc3ae770915b",
    "aws_cognito_region": process.env.VUE_APP_AWS_REGION || "eu-central-1",
    "aws_user_pools_id": process.env.VUE_APP_COGNITO_USER_POOL_ID || "eu-central-1_oAHKpBUPy",
    "aws_user_pools_web_client_id": process.env.VUE_APP_COGNITO_CLIENT_ID || "3cpqo58t0b78lkto00seahnc6h",
    "oauth": {}
};


export default awsmobile;
